import register from '../../../../global/js/registry';
export default register('o-grid-container', () => import(/* webpackMode: "lazy" */ './o-grid-container.controller'));
